<template>
  <div>
    <table>
      <thead>
        <tr>
          <th class="text-center">
            Informado
          </th>
          <th class="text-center">
            Pago
          </th>
          <th class="text-center">
            Glosado
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>R$ {{ valorInformado | formatPrice }}</td>
          <td class="success--text">R$ {{ valorPago | formatPrice  }}</td>
          <td class="red--text">R$ {{ valorGlosado | formatPrice  }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    valorInformado: Number,
    valorPago: Number,
    valorGlosado: Number
  }
}
</script>

<style scoped>
p {
  margin-top: 12px;
  font-weight: 700;
}

table, td {
  border: 1px solid white;
}

table {
  font-weight: 700;
}
thead {
  background-color: #EFF3F8;
}
th {
  border: solid 1px #EFF3F8;
}
td {
  padding: 4px 16px
}
.first-row td, tr {
  border-bottom: 1px solid #D1DCEA;
}
</style>
